export const SITE_STATUS_META = {
  CRITIQUE: { label: "Critique", bg: "bg-red-50", text: "text-red-600", dot: "bg-red-500" },
  IMPORTANT: { label: "Important", bg: "bg-orange-50", text: "text-orange-600", dot: "bg-orange-500" },
  AMELIORER: { label: "À améliorer", bg: "bg-yellow-50", text: "text-yellow-700", dot: "bg-yellow-500" },
  REUSSI: { label: "Réussi", bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500" },
  NON_VERIFIABLE: { label: "Non vérifiable", bg: "bg-slate-100", text: "text-slate-500", dot: "bg-slate-400" },
  NON_APPLICABLE: { label: "Non applicable", bg: "bg-slate-50", text: "text-slate-400", dot: "bg-slate-300" },
};

export const SITE_CATEGORIES = [
  { key: "seo", label: "SEO" },
  { key: "seo_local", label: "SEO local" },
  { key: "technique", label: "Technique" },
  { key: "conversion", label: "Conversion" },
];
